import validationErrors from '@utils/validationErrors';
import Validator from 'validatorjs';

export default class ValidatorService {
    constructor() {
        Validator.setMessages("hr", validationErrors);
    }

}
